import { render, staticRenderFns } from "./ReviewHistory.vue?vue&type=template&id=53c10b84&scoped=true&"
import script from "./ReviewHistory.vue?vue&type=script&lang=js&"
export * from "./ReviewHistory.vue?vue&type=script&lang=js&"
import style0 from "./ReviewHistory.vue?vue&type=style&index=0&id=53c10b84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c10b84",
  null
  
)

export default component.exports